// Firebase SDK setup
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAYuIVz3rLcE0vd0CZqsI6T9vJysV7Hjzc",
  authDomain: "asdflobeta.firebaseapp.com",
  projectId: "asdflobeta",
  storageBucket: "asdflobeta.firebasestorage.app",
  messagingSenderId: "521849444854",
  appId: "1:521849444854:web:b7b28a1a3a1056758d0fd7",
  measurementId: "G-XXXXXXXXXX" // Add your measurement ID if using Google Analytics
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Initialize Cloud Functions with region
const functions = getFunctions(app, 'us-central1');

// Initialize Cloud Storage
export const storage = getStorage(app);

export { functions, httpsCallable };

// Configure CORS for development
if (process.env.NODE_ENV === 'development') {
  functions.httpsCallable = (name, options) => {
    const callable = httpsCallable(functions, name, { ...options, region: 'us-central1' });
    return async (data) => {
      try {
        return await callable(data);
      } catch (error) {
        console.error('Callable function error:', error);
        throw error;
      }
    };
  };
}
